import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';

import { NO_VALUE } from '../dash/dash.pipe';

@Pipe({
  name: 'minutesOrHours',
})
export class MinutesOrHoursPipe implements PipeTransform {
  transform(minutes: number): string {
    const isNull = isNil(minutes);
    const isPositiveFiniteNumber = typeof minutes === 'number' && isFinite(minutes) && minutes > 0;

    if (isNull || !isPositiveFiniteNumber) {
      return NO_VALUE;
    }

    if (minutes < 60) {
      minutes = Math.floor(minutes);

      return minutes + ' min';
    }
    const hours = Math.floor(minutes / 60);
    const min = Math.floor(minutes % 60);
    if (min) {
      return hours + ' h ' + min + ' min';
    } else {
      return hours + ' h';
    }
  }
}
